import { useEffect, useState } from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

import useProductStore from '@/store/product';

/**
 * 全局流控限制弹窗组件
 */
const FlowControlModal = () => {
  const { flowControlState } = useProductStore();
  const { rateLimitInfo } = flowControlState;

  const [visible, setVisible] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);

  useEffect(() => {
    if (rateLimitInfo) {
      setVisible(true);
      setRemainingTime(Math.ceil(rateLimitInfo.waitTime / 1000));
    } else {
      setVisible(false);
      setRemainingTime(0);
    }
  }, [rateLimitInfo]);

  // 倒计时效果
  useEffect(() => {
    if (remainingTime > 0) {
      const timer = setTimeout(() => {
        setRemainingTime(remainingTime - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [remainingTime]);

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      centered
      width={420}
      maskStyle={{
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
      }}
    >
      <div className="bg-white">
        {/* 标题区域 */}
        <div className="flex items-center mb-[20px]">
          <InfoCircleOutlined className="text-[18px] text-[#FF9800] mr-[8px]" />
          <h3 className="text-[16px] font-bold text-[#333333] m-0">访问过于频繁</h3>
        </div>

        {/* 内容区域 */}
        <div className="">
          {/* 提示文本 */}
          <div className="mb-[20px]">
            <p className="text-[14px] text-[#666666] leading-[22px] m-0">
              为了保护系统稳定和您的账户安全，请耐心等待。您的请求已暂时受到限制。
            </p>
          </div>

          {/* 倒计时区域 */}
          <div className="bg-[#F8F9FA] rounded-[8px] px-[24px] py-[20px] mb-[20px]">
            <div className="relative top-[-6px] flex items-baseline justify-center">
              <span className="text-[14px] text-[#666666] mr-[8px]">请勿刷新</span>
              <span className="text-[14px] text-[#666666] mr-[4px]">等待</span>
              <span className="text-[36px] font-bold text-primary">{remainingTime}</span>
              <span className="text-[14px] text-[#666666] ml-[4px]">秒</span>
            </div>
          </div>

          {/* 温馨提示 */}
          <div className="bg-[#EDFAFF] rounded-[8px] px-[16px] py-[14px]">
            <div className="text-[13px] leading-[20px]">
              <p className="m-0 mb-[8px] font-medium">温馨提示：</p>
              <ul className="m-0 pl-[18px] space-y-[6px] list-disc">
                <li>为保障系统稳定，请合理控制访问频率</li>
                <li>倒计时结束后即可继续访问</li>
                <li>如有疑问，请联系在线客服</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FlowControlModal;
